import React, { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import {
  Footer,
  Blog,
  Possibility,
  Services,
  WhatScrobits,
  Header,
  ContactUs,
  Career,
  Forms,
  Products,
} from "./containers";
import { CTA, Portfollio, Collaborations, Navbar, SiteMap } from "./components";

import "./App.css";
import CareerDetail from "./containers/career/careerDetail/CareerDetail";
import Achievements from "./containers/achievements/Achievements";
import ChatbotUI from "./components/chatbot/ChatbotUI";

const App = () => {
  return (
    <div className="App">
      <div className="gradient__bg gradient__bg-container " />
      <Navbar />

      <Switch>
        <Route exact path="/">
          <Header />

          <ChatbotUI />
          <Achievements />
          <Portfollio />
          <WhatScrobits />

          <div className="bubble__blur-container">
            <div className="bubble__blur-service"></div>
          </div>
          <Services />
          <div className="bubble__blur-container">
            <div className="bubble__blur"></div>
          </div>
          <Possibility />
          <CTA />
          <Blog />
          <div className="bubble__blur-container">
            <div className="bubble__blur-contact"></div>
          </div>
          <Collaborations />

          <ContactUs />
          <div className="bubble__blur-container">
            <div className="bubble__blur"></div>
          </div>

          <Career />
        </Route>
        <Route exact path="/get-started">
          <Forms />
        </Route>
        <Route exact path="/jobs/:id">
          <CareerDetail />
        </Route>
        <Route exact path="/sitemap">
          <SiteMap />
        </Route>
        <Route exact path="/product">
          <Products />
        </Route>
      </Switch>
      <Footer />
    </div>
  );
};

export default App;
